<mat-form-field class="date-field" appearance="outline">
    <mat-label>{{normalizedLabel}}</mat-label>
    <input type="date" matInput name="{{label}}-{{key}}"
        [required]="required" [disabled]="disabled" [readonly]="readonly"
        attr.data-testid="record-{{label}}-date"
        [(ngModel)]="date" (ngModelChange)="onDateChange()">
</mat-form-field>
